import angular from 'angular';

module.exports = angular.module('market.routes.property-terms', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('property-terms', {
    parent: 'root',
    url: '/property-terms',
    templateUrl: '/templates/common/property-terms.html',
    data: {
      meta: {
        titleSuffix: ' | Our Property Terms',
        description:
          "Read the full terms and conditions for which Opendoor will repurchase a " +
          "Buyer's eligible property as part of our 90-day satisfaction guarantee.",
        keywords: 'Opendoor Property Terms',
      }
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/property-terms.js
 **/